import React from "react";
import { Modal } from "reactstrap";
import _ from "lodash";
import Socket from "socket";
import { connect } from "react-redux";

const ConfirmationModal = (props) => {
  const handle_back = () => {
    props.setModalVisible(!props.modalVisible);
  };
  const handle_end_slides = () => {
    const room_id = _.get(props, "gameReducer.roomObj.id");
    const data = { action: "update-status", roomId: room_id };
    Socket.sendMessage(data);
  };
  const presenting = _.get(props, "paramsReducer.gameObj.presenting");
  const end_slides_yes = _.get(presenting, "end_slides_yes", "YES");
  const end_slides_back = _.get(presenting, "end_slides_back", "BACK");
  const end_slides_text = _.get(presenting, "end_slides_text", "End Slides?");

  return (
    <Modal
      isOpen={props.modalVisible}
      centered={true}
      className="slideKick-confirmation-modal"
      contentClassName="slideKick-confirmation-modal-content"
      backdropClassName="slideKick-confirmation-modal-backdrop"
      toggle={() => {
        props.setModalVisible(!props.modalVisible);
      }}
    >
      <div className="modal-body">
        <div>
          <p className="text-modal">{end_slides_text}</p>
          <button className="btn-modal btn-yes" onClick={handle_end_slides}>
            {end_slides_yes}
          </button>
          <button className="btn-modal btn-back" onClick={handle_back}>
            {end_slides_back}
          </button>
        </div>
      </div>
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  paramsReducer: state.paramsReducer,
  gameReducer: state.gameReducer,
});
const mapDispatchToProps = (dispatch) => {
  return {};
};
export default connect(mapStateToProps, mapDispatchToProps)(ConfirmationModal);
